import { render } from "./Index.vue?vue&type=template&id=77f252fe&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=77f252fe&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=77f252fe&lang=scss&scoped=true"

import exportComponent from "/mnt/e/med/Project/primitive/whouse-disperindag/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f252fe"]])

export default __exports__